// extracted by mini-css-extract-plugin
export default {"comment-indicator":"ContentCell-module__comment-indicator--Avv5C","in-progress-comment-indicator":"ContentCell-module__in-progress-comment-indicator--Onob7"};